import { Route } from 'react-router-dom';
import MobileEncounterDetails from './components/PastEncounter/MobileEncounterDetails';
import PastEncounters from './components/PastEncounter/PastEncounter';
import { StripeCheckoutSuccess } from './components/Payments/StripeCheckoutSuccess';
import Settings from 'src/components/pageComponents/Settings';
import EncounterSettings from './components/Settings/Settings';

import AuraRecycleBin from './components/AuraRecycleBin/AuraRecycleBin.page';
import Memory from './components/Memory/Memory';
import AutoTemplates from '../AutoTemplate/components/pageComponents/AutoTemplate';
import ZoomIntegrationTile from '../common/components/ZoomIntegrationTile';

export const getAmbientSoloRoutes = ({ isMinimized, setIsMinimized }) => {
  const pages = [
    {
      path: '/encounters',
      Component: PastEncounters,
    },
    {
      path: '/checkout_success',
      Component: StripeCheckoutSuccess,
    },
    {
      path: '/mobileEncounterDetails/:encounter_id',
      Component: MobileEncounterDetails,
    },
    {
      path: '/setting',
      Component: EncounterSettings,
    },
    {
      path: '/settings',
      Component: Settings,
    },
    {
      path: '/encountersbin',
      Component: AuraRecycleBin,
    },
    {
      path: '/memory',
      Component: Memory,
    },
    {
      path: '/autotemplate',
      Component: AutoTemplates,
    },
    {
      path: '/integrations',
      Component: ZoomIntegrationTile,
    },
  ];

  return pages.map((route) => {
    const { path, Component } = route;
    return (
      <Route
        key={path}
        path={path}
        element={
          <Component
            isMinimized={isMinimized}
            setIsMinimized={setIsMinimized}
          />
        }
      />
    );
  });
};
